const templateUrl = require('./views/send-shipment-now-button.html');

module.exports = {
  bindings: {
    shipment: '<ogFor'
  },
  controller: 'SendShipmentNowController',
  templateUrl: templateUrl
};
